import React, { useState } from 'react'

import styled from 'styled-components'
import DatePicker from 'react-datepicker'
import moment from 'moment'

interface HourFieldProps {
    hour: string
    setHour: (hour: string) => void
}

export function HourField({ hour, setHour }: HourFieldProps) {
    const [open, setOpen] = useState(false)

    function hourToMoment(hour: string): moment.Moment {
        /*
            The options have a minute interval and the value is only selected automatically
            if the current minute is available in the options, otherwise no time is selected and
            therefore the value is saved as empty in the db
        */
        const nextMinuteAvailableInOptions = (2 * Math.round(moment().minute() / 2)) % 60

        try {
            if (hour) return moment(hour, 'LT')
            return moment().minute(nextMinuteAvailableInOptions)
        } catch (error) {
            return moment().minute(nextMinuteAvailableInOptions)
        }
    }

    return (
        <HourFieldContainer>
            <HourFieldContent>
                <DatePicker
                    selected={hourToMoment(hour)}
                    onChange={(e: moment.Moment) => {
                        setHour(e.startOf('minutes').format('LT'))
                        setOpen(false)
                    }}
                    onInputClick={() => {
                        if (!open) {
                            setOpen(true)
                        }
                    }}
                    onClickOutside={() => {
                        if (open) setOpen(false)
                    }}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={2}
                    timeCaption="Time"
                    dateFormat="hh:mm A"
                    placeholderText="hh:mm A"
                    onKeyDown={e => {
                        e.preventDefault()
                    }}
                />
                <Divisor />
                <i
                    className={`fas fa-caret-${open ? 'up' : 'down'}`}
                    style={{
                        transition: 'all 0.5s'
                    }}
                />
            </HourFieldContent>
        </HourFieldContainer>
    )
}

const HourFieldContainer = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
`

const Divisor = styled.div`
    position: absolute;
    right: 30px;
    width: 1px;
    height: 20px;

    background-color: var(--gray-500);
`

const HourFieldContent = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    width: 237px;
    height: 36px;

    border: 1px solid var(--gray-400);
    border-radius: 3px;

    background-color: var(--gray-0);

    .react-datepicker-popper[data-placement^='bottom'] {
        margin-top: 0;

        .react-datepicker__time-container .react-datepicker__time-box ul li {
            color: var(--gray-800);
        }

        .react-datepicker__time-container
            .react-datepicker__time
            .react-datepicker__time-box
            ul.react-datepicker__time-list
            li.react-datepicker__time-list-item--selected {
            color: var(--gray-0) !important;
        }
    }

    .react-datepicker__input-container {
        input {
            border: 1px solid transparent;
            border-radius: 3px;

            cursor: default;
        }
    }

    .react-datepicker__triangle {
        display: none;
    }

    .react-datepicker__time-container {
        width: 234px;

        .react-datepicker__time-box {
            width: 85px;
        }

        .react-datepicker__header--time {
            display: none;
        }
    }

    i {
        position: absolute;
        right: 11px;
        cursor: pointer;

        font-size: 16px;

        color: var(--blue-500);

        &:hover {
            opacity: 0.6;
        }
    }
`
